function formatPath(url) {
  const path = url.split('?')[0];
  return path.replace(/^\/|\/$/g, '').replace(/\//g, '_');
}

export default formatPath;
